import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { GET_APPS, TOGGLE_NOTIFICATION, APPS_LOADING, GET_APP_CATALOG, APP_CATALOG_LOADING } from '@app/store/constants/launchpad.constants';
import { launchPadService } from '@app/services/launchPad.service';
import { DispatchFunction, ILaunchPadApp, OrderType, Order } from '@app/models';

export function getAppsRequest(orderBy: string, asc: string): DispatchFunction {
    return ((dispatch: Dispatch) => {
        dispatch(getAppsLoading(true));
        dispatch(getAppCatalogLoading(true));
        launchPadService.getApps()
            .then((response: AxiosResponse) => {

                dispatch(sortAppsByLaunchTime(response.data.value, Order.desc, dispatch));
                dispatch(getAppsLoading(false));
            });

        launchPadService.getAppCatalog(orderBy, asc)
            .then((response: AxiosResponse) => {
                dispatch(getAppCatalog(response.data.value));
                dispatch(getAppCatalogLoading(false));
            })
    });
}

export function sortAppsByLaunchTime(apps: ILaunchPadApp[], sortDirection: OrderType, dispatch: Dispatch) {
    apps.sort((a, b) => {
        a.UserConfiguration = a.UserConfiguration || {};
        b.UserConfiguration = b.UserConfiguration || {};

        let aDate: number = new Date(a.UserConfiguration.LastLaunched || 0).getTime();
        let bDate: number = new Date(b.UserConfiguration.LastLaunched || 0).getTime();

        if (sortDirection === Order.desc) {
            return bDate - aDate;
        }
        else {
            return aDate - bDate;
        }
        
    });

    dispatch(getAppsLoading(false));

    return {
        payload: apps,
        type: GET_APPS
    };
}

export function sortAppsByName(apps: ILaunchPadApp[], sortDirection: OrderType, dispatch: Dispatch) {
    apps.sort((a, b) => {
        let aName: string = a.DisplayName.toLowerCase().replace(' ', '');
        let bName: string = b.DisplayName.toLowerCase().replace(' ', '');

        let upper = 1, lower = -1;

        if (sortDirection === Order.desc) {
            upper = -1;
            lower = -1;
        }

        if (aName > bName) {
            return upper;
        } else if (bName > aName) {
            return lower;
        } else {
            return 0;
        }
    });

    dispatch(getAppsLoading(false));

    return {
        payload: apps,
        type: GET_APPS
    };
}

export function getApps(apps: ILaunchPadApp[]) {
    return {
        payload: apps,
        type: GET_APPS,
    };
}

export function getAppCatalog(apps: ILaunchPadApp[]) {
    return {
        payload: apps,
        type: GET_APP_CATALOG,
    };
}

export function toggleNotification(state: boolean) {
    return {
        payload: state,
        type: TOGGLE_NOTIFICATION,
    };
}

export function getAppsLoading(loading: boolean) {
    return {
        payload: loading,
        type: APPS_LOADING
    };
}

export function getAppCatalogLoading(loading: boolean) {
    return {
        payload: loading,
        type: APP_CATALOG_LOADING
    };
}